import React from 'react';

import Checkbox from 'react-simple-checkbox';

import './control.scss';


export class Control extends React.Component {

    render() {
        const {layers, activeLayers, label, description, setLayer} = this.props;

        const checkboxesJsx = layers.map( (layer) => {
            return (
                <div key={layer.number}>
                    <Checkbox
                        color={layer.color}
                        size={2}
                        tickSize={3}
                        backAnimationDuration={0}
                        tickAnimationDuration={0}
                        checked={activeLayers.has(layer.number)}
                        onChange={(isChecked) => setLayer(layer.number, isChecked)}
                    />
                    <span className='layer-label'>
                        {layer.label} 
                    </span>
                </div>
            );
        });

        let descriptionJsx = null;
        if (label && description) {
            descriptionJsx = (
                <div>
                    <h2>
                        {label}
                    </h2>
                    <p>
                        {description}
                    </p>
                </div>
            );
        }
        else {
            descriptionJsx = (
                <div>
                    <h2>
                        Boxes
                    </h2>
                    <div>
                        <i>Click on a box label to see details here.</i>
                    </div>
                </div>
            )
        }

        return (
            <div className='control-panel'>
                <div className='control-content'>
                    <div className='diagram-dropdown'>
                        <h2>Diagram:</h2>
                        <select name='diagrams' value={this.props.diagramName} 
                            onChange={(event) => this.props.setDiagramName(event.target.value)}>
                            <option value='ERCOT'>ERCOT</option>
                            <option value='NW'>BPA</option>
                        </select>
                    </div>
                    <div className='layers'>
                        <h2>
                            Layers
                        </h2>
                        <div>
                            <i>Check boxes to show relationships:</i>
                        </div>
                        {checkboxesJsx}
                    </div>
                    {descriptionJsx}
                </div>
            </div>
        )
    }
}